import script from "./BriefOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./BriefOverview.vue?vue&type=script&setup=true&lang=ts"

import "./BriefOverview.vue?vue&type=style&index=0&id=1828cbf0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1828cbf0"]])

export default __exports__